import { IExecutionProgressTracking } from 'types/executionProgressTrackings';
import {
  IExecutionProgressStatus,
  IExecutionProgressStatusAttribute
} from 'types/executionProgressStatuses';

export const findLastExecutionProgressTrackingLetter = (
  executionProgressTracking: IExecutionProgressTracking,
  executionProgressStatuses: (
    | IExecutionProgressStatusAttribute
    | IExecutionProgressStatus
  )[]
) => {
  let result;

  executionProgressTracking.kind.split('').map((letter) => {
    if (
      executionProgressStatuses.find((attribute) => attribute.kind === letter)
    ) {
      result = letter;
    }
  });

  return result;
};
